// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import YouTubePlayer from 'react-player/lib/players/YouTube'
import VimeoPlayer from 'react-player/lib/players/Vimeo'
import FilePlayer from 'react-player/lib/players/FilePlayer'

class MediaPlayer extends React.Component {
	static defaultProps = {
		url: '',
		id: '',
		service: ''
	}

	constructor( props ) {
		super( props )

		this.state = {
			isPlaying: false,
			played: 0,
			loaded: 0,
			duration: 0
		}
	}

	componentWillReceiveProps( nextProps ) {
		const { url } = this.props

		if ( url != nextProps.url ) {
			this.setState({
				isPlaying: false,
				played: 0,
				loaded: 0,
				duration: 0
			})
		}
	}

	handleWrapClick = ( e ) => {
		if ( this.wrap == e.target ) {
			this.setState({
				isPlaying: ! this.state.isPlaying
			})
		}
	}

	handleClick = ( e ) => {
		this.setState({
			isPlaying: ! this.state.isPlaying
		})
	}

	onPause = () => {
		this.setState({
			isPlaying: false
		})
	}

	onProgress = ( state ) => {
		if ( ! this.state.seeking ) {
			this.setState( state )
		}
	}

	onDuration = ( duration ) => {
		this.setState( { duration } )
	}

	handleSeekMouseDown = ( e ) => {
		this.setState({
			seeking: true
		})
	}

	handleSeekChange = ( e ) => {
		this.setState({
			played: parseFloat( e.target.value )
		})
	}

	handleSeekMouseUp = ( e ) => {
		this.setState({
			seeking: false
		})

		this.player.seekTo( parseFloat( e.target.value ) )
	}

	render() {
		let { wrapStyle, thumb, image, id, service, url, file, type, width, height, aspectRatio } = this.props
		let { isPlaying } = this.state
		let wrapClass = isPlaying ? 'media-player is-playing' : 'media-player'

		if ( 'audio' == type ) {
			wrapClass += ' audio-player'
		}

		let video

		if ( id && 'youtube' == service ) {
			url = `https://www.youtube.com/watch?v=${id}`
		} else if ( id && 'vimeo' == service ) {
			url = `https://vimeo.com/${id}`
		}

		if ( url ) {
			if ( url.indexOf( 'vimeo' ) > -1 ) {
				video = (
					<VimeoPlayer
						playing={ isPlaying }
						url={ url }
						controls={ true }
						onPause={ this.onPause }
						onEnded={ this.onPause }
					/>
				)
			} else {
				video = (
					<YouTubePlayer
						playing={ isPlaying }
						url={ url }
						controls={ true }
						onPause={ this.onPause }
						onEnded={ this.onPause }
					/>
				)
			}
		} else if ( file ) {
			let forceAudio = 'audio' == type ? true : false

			video = (
				<FilePlayer
					ref={ ( e ) => { this.player = e } }
					playing={ isPlaying }
					url={ file }
					controls={ true }
					onPause={ this.onPause }
					onEnded={ this.onPause }
					onProgress={ this.onProgress }
					onDuration={ this.onDuration }
				/>
			)
		}

		return (
			<div className={ wrapClass } style={ wrapStyle } onClick={ this.handleWrapClick } ref={ ( e ) => { this.wrap = e } }>
				{ video }
			</div>
		)
	}
}

export default MediaPlayer



// WEBPACK FOOTER //
// ./components/MediaPlayer/MediaPlayer.jsx